<template>
  <div class="mOperation-wrap">
    <!----------- operation ---------->
    <div class="mOperation">
      <ul class="clearfix">
        <li class="pull-left">
          <a href="javascript: " v-if="showBackButton" @click="goBack()" class="btn btn-hollow btn-icon" name="addBtn" ><i class="mng icon-add-stroke"></i>返回</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import {STORE_APP_MUTATION_TYPES} from '../../libs/constants'
  export default {
    name: 'iframe-top-operation',
    props: {
      showBackButton: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    },
    methods: {
      goBack() {
        this.$store.commit(STORE_APP_MUTATION_TYPES.HIDDEN_IFRAME)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/iframe/iframe-top-operation.vue